import React from "react";
import { useNavigate } from "react-router-dom";
import { Wine, ForkKnife, Martini, ArrowRight } from "@phosphor-icons/react";

export const MENU_META = {
  cellar_door: {
    title: "Cellar Door",
    tagline: "Grazing & tasting plates",
    subtitle: "Every tasting pairs beautifully with our grazing selection.",
    image: "/hero.jpg",
    icon: Wine,
  },
  fathers_day: {
    title: "Fathers Day",
    tagline: "Our special Fathers Day menu",
    subtitle: "A hearty spread to celebrate Dad — starters, mains & something for the kids.",
    image:
      "https://images.unsplash.com/photo-1547573854-74d2a71d0826?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: ForkKnife,
  },
  drinks: {
    title: "Drinks",
    tagline: "Wine, beer, spirits & cocktails",
    subtitle: "Our full drinks list — sent straight to the bar.",
    image: "/drinks.webp",
    icon: Martini,
  },
};

export default function MenuLanding() {
  const navigate = useNavigate();
  const tiles = ["cellar_door", "drinks"];

  return (
    <div className="min-h-screen bg-cream text-[#2D2825]">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-cream/80 border-b border-[#EAE5DE]">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 h-20 flex items-center">
          <img
            src="/gledswood-wordmark.png"
            alt="Gledswood Homestead & Winery"
            className="h-10 sm:h-12 w-auto object-contain"
            data-testid="brand-logo"
          />
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <p className="flex items-center gap-2 text-wine text-xs uppercase tracking-[0.3em] mb-4">
          <Wine size={16} weight="fill" /> Est. 1810 · Dine In
        </p>
        <h1 className="font-heading font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-[1.02]">
          Choose your menu
        </h1>
        <p className="text-[#5C544D] mt-4 max-w-xl text-base">
          Select a menu to browse, then send your order straight to the kitchen from your table.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
          {tiles.map((key, i) => {
            const m = MENU_META[key];
            const Icon = m.icon;
            return (
              <button
                key={key}
                data-testid={`menu-tile-${key}`}
                onClick={() => navigate(`/menu/${key}`)}
                className="group relative text-left rounded-3xl overflow-hidden border border-[#EAE5DE] shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-1.5 transition-transform duration-300 animate-fade-up"
                style={{ animationDelay: `${i * 120}ms` }}
              >
                <div className="relative h-72 sm:h-80">
                  <img
                    src={m.image}
                    alt={m.title}
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10" />
                  <div className="relative h-full flex flex-col justify-end p-7">
                    <Icon size={30} weight="fill" className="text-cream/90 mb-3" />
                    <p className="text-cream/70 text-xs uppercase tracking-[0.25em] mb-1">
                      {m.tagline}
                    </p>
                    <h2 className="font-heading text-cream text-3xl sm:text-4xl tracking-tight">
                      {m.title}
                    </h2>
                    <span className="mt-4 inline-flex items-center gap-2 text-cream text-sm font-medium">
                      View menu
                      <ArrowRight
                        size={16}
                        weight="bold"
                        className="group-hover:translate-x-1 transition-transform"
                      />
                    </span>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </main>
    </div>
  );
}
